import { createIntegrationConnectionConfigurationClassMixin } from '../../../connection/configuration/IntegrationConnectionConfigurationMixin';

export interface KiteLocationConfigurationValid {
    type: 'VALID';
    kiteLocationId: string;
}

export interface KiteLocationConfigurationMissing {
    type: 'MISSING_LOCATION_ID';
}

export type KiteLocationConfigurationUnion =
    | KiteLocationConfigurationMissing
    | KiteLocationConfigurationValid;

export class KiteLocationConfiguration extends createIntegrationConnectionConfigurationClassMixin<
    KiteLocationConfigurationUnion,
    'KITE_LOCATION'
>('KITE_LOCATION') { }
